import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from '../configuration.service';
import { EndpointFactory } from '../endpoint-factory.service';
import { CognitoService } from '../cognito/cognito.service';
import { GlobalSupplier } from 'src/app/models/suppliers/global-supplier.model';

@Injectable()
export class GlobalSupplierEndpoint extends EndpointFactory {
  private host = environment.newlambdaBaseUrl;
  constructor(protected http: HttpClient, configurations: ConfigurationService, injector: Injector, cognitoService: CognitoService) {
    super(http, configurations, injector, cognitoService);
  }

  /**
   * Get the suppliers of Overview and Selfnet joined by code
   */
  public getGlobalSuppliers(): Observable<GlobalSupplier[]> {
    const url = `${this.host}suppliers`;

    return this.http.get<GlobalSupplier[]>(url, this.getRequestHeaders());
  }
}
